/* eslint-disable react/sort-comp */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './Filter.module.scss';
import Clickable from '../../../../components/clickable/Clickable';
import ColumnCustomizer from './ColumnCustomizer';
import IconButton from '../../../../components/iconButton';
import edit from '../../../../icons/edit.svg';
import Separator from '../../../../components/separator/Separator';
import print from '../../../../icons/exportIcon.png';
import ImportExcel from '../Components/ImportExcel';

class Filter extends Component {
  child = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      openColumnCustomizer: false
    };
    this.actionRef = React.createRef();
  }

  toggleColumCustomizer = () => {
    const { openColumnCustomizer } = this.state;
    this.setState({ openColumnCustomizer: !openColumnCustomizer });
  };

  handleChangeColumns = (cols) => {
    const { columnData, handleActionPopup, editColumns } = this.props;
    localStorage.setItem(editColumns, JSON.stringify(cols));
    columnData(cols);
    handleActionPopup();
    this.toggleColumCustomizer();
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };


  render() {
    const {
      actionPopup,
      handleActionPopup,
      editColumns,
      defaultColumns,
      columnData,
      filterCategories,
      handleDropdown,
      toggleUploadModal,
      uploadModal,
      downloadCSVTemplate,
      excelModal,
      fieldsForMapping,
      toggleExcelModal,
      user,
      exportToExcel
    } = this.props;
    const { openColumnCustomizer } = this.state;

    let columns = localStorage.getItem(editColumns)
    ? JSON.parse(localStorage.getItem(editColumns))
    : defaultColumns;

    return (
      <>
        <div className={styles.toolbar}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
            {handleActionPopup && (
              <>
                <div ref={this.actionRef}>
                  <Clickable className={`${styles.actionsBtn1} ${styles.formActionBtn}`} onClick={() => handleActionPopup()}>
                    <FormattedMessage id="wildlifelog.list.action" defaultMessage="Actions" />
                  </Clickable>
                  {actionPopup && (
                    <ul className={`${styles.actionpopup} ${actionPopup ? styles.open : ''}`}>
                      {editColumns && (
                        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
                        <li className={styles.item} onClick={this.toggleColumCustomizer}>
                          <IconButton icon={edit} />
                          <FormattedMessage
                            id="forms.edit.columns"
                            defaultMessage="Edit Columns"
                          />
                        </li>
                      )}{user?.permissions?.vehicle_permit?.includes('add_vehiclepermit')
                       && (<li className={styles.item}>
                            <div
                              onClick={(e) => { toggleUploadModal(); e.stopPropagation(); }}
                              onKeyPress={(e) => { toggleUploadModal(); e.stopPropagation(); }}
                              role="button"
                              tabIndex={0} style={{ fontSize: '1rem' }}>
                              <IconButton icon={print} />
                              {' '}
                              <FormattedMessage id="forms.edit.import.excel" defaultMessage="Import CSV" />
                            </div>
                           </li>)
                      }
                      <li className={styles.item}>
                          <div
                            onClick={(e) => { exportToExcel(); e.stopPropagation(); }}
                            onKeyPress={(e) => { exportToExcel(); e.stopPropagation(); }}
                            role="button"
                            tabIndex={0} style={{ fontSize: '1rem' }}>
                            <IconButton icon={print} />
                            {' '}
                            <FormattedMessage id="wildlifelog.detail.expToExcel" defaultMessage="Export to Excel" />
                          </div>
                      </li>
                    </ul>
                  )}
                </div>
              </>
            )}
            {filterCategories && (
              <>
                <Separator />
                <Clickable className={`${styles.actionsBtn1} ${styles.formActionBtn}`} onClick={() => handleDropdown()}>
                  <FormattedMessage id="workorders.list.filters" defaultMessage="Filters " />
                </Clickable>
              </>
            )}
            </div>

         {openColumnCustomizer && (
              <ColumnCustomizer
                cols={columns}
                onClose={this.toggleColumCustomizer}
                onModify={this.handleChangeColumns}
                columnData={columnData}
                isADP
              />
            )}
            {(uploadModal || excelModal) && fieldsForMapping.length > 0 && (
              <ImportExcel
                excelModal={excelModal}
                uploadModal={uploadModal}
                toggleUploadModal={toggleUploadModal}
                toggleExcelModal={toggleExcelModal}
                sourceComponent="avp"
                downloadCSVTemplate={downloadCSVTemplate}
                fieldsForMapping={fieldsForMapping}
              />)}
          </div>
        </div>
      </>
    );
  }
}


export default Filter;
